import { useContext } from "react";
import { AuthContext } from "../component/AuthContext";

export default function useAuth() {
  return useContext(AuthContext);
}
